module.exports = __webpack_public_path__ + "static/media/FooterNewMay13_2025.e898f630.jpg";